import {Component, OnDestroy, OnInit} from '@angular/core';
import {RestApiService} from '../rest-api.service';
import {ActivatedRoute} from '@angular/router';
import {MessageService} from '../message.service';
import {NotifierService} from 'angular-notifier';
import {AngularGridInstance, FieldType, GridOption} from 'angular-slickgrid';
import {Subscription} from 'rxjs';

@Component({
    selector: 'app-email-search',
    templateUrl: './email-search.component.html',
    styleUrls: ['./email-search.component.css']
})
export class EmailSearchComponent implements OnInit, OnDestroy {
    private respObject: any;
    private notifier: NotifierService;
    typeChecked: number;
    columnDefinitions = [];
    clientId: number;
    userGroups = [];
    public grpLevel: number;
    userGroupId: number;
    groupName: string;
    userGroupSelected: number;
    private userAuth: Subscription;
    private ticket_no: string;
    gridOptions: GridOption;
    angularGrid: AngularGridInstance;
    gridObj: any;
    dataset: any[];
    seq: number;
    displayCit: boolean;
    displayCr: boolean;
    displayPr: boolean;
    isViewTicket: boolean;
    private masterCloseSubscribe: Subscription;
    inciId: number;
    displaySSC: boolean;
    displayIMS: boolean;
    displayCHR: boolean;
    displayAPPS: boolean;

    constructor(private _rest: RestApiService, private actRoute: ActivatedRoute, private messageService: MessageService,
                notifier: NotifierService) {
        this.notifier = notifier;
        this.masterCloseSubscribe = this.messageService.masterCloseModalSubject.subscribe((data) => {
            this.getTicketDetails();
        });
    }

    angularGridReady(angularGrid: AngularGridInstance) {
        // console.log('grid initiate');
        this.angularGrid = angularGrid;
        this.gridObj = angularGrid && angularGrid.slickGrid || {};
    }

    ngOnInit(): void {
        this.isViewTicket = true;
        this.displayCit = false;
        this.displayCr = false;
        this.displayPr = false;
        this.displaySSC = false;
        this.displayCHR = false;
        this.displayIMS = false;
        this.displayAPPS = false;
        this.gridOptions = {
            enableAutoResize: true,       // true by default
            enableCellNavigation: true,
            enableFiltering: true,
            editable: true,
            rowSelectionOptions: {
                selectActiveRow: false
            },
            // enableCheckboxSelector: true,
            enableRowSelection: true,

        };
        this.dataset = [];
        this.actRoute.queryParams.subscribe(params => {
            const userId = this.messageService.getUserId();
            const token = this.messageService.getToken();

            if (userId !== null && userId !== undefined && token !== null && token !== undefined) {
                this.messageService.tokenSubject.next();
                this.ticket_no = params['ticket_no'];
                if (this.messageService.clientId) {
                    this.clientId = this.messageService.clientId;
                    this.userGroups = this.messageService.groupId;
                    if (this.userGroups !== undefined) {
                        if (this.messageService.getSupportGroup() === null) {
                            this.userGroupId = this.userGroups[0].groupId;
                            this.groupName = this.userGroups[0].grpName;
                            this.grpLevel = this.userGroups[0].level;

                        } else {
                            const group = this.messageService.getSupportGroup();
                            // // console.log(group, typeof group);
                            this.userGroupId = group.groupId;
                            this.groupName = group.grpName;
                            this.grpLevel = group.level;
                        }
                        this.userGroupSelected = this.userGroupId;
                    }
                    this.onPageLoad();
                } else {
                    this.userAuth = this.messageService.getClientUserAuth().subscribe(auth => {
                        this.clientId = auth[0].clientId;
                        this.userGroups = auth[0].groupId;
                        if (this.userGroups !== undefined) {
                            if (this.messageService.getSupportGroup() === null) {
                                this.userGroupId = this.userGroups[0].groupId;
                                this.groupName = this.userGroups[0].grpName;
                                this.grpLevel = this.userGroups[0].level;

                            } else {
                                const group = this.messageService.getSupportGroup();
                                // // console.log(group, typeof group);
                                this.userGroupId = group.groupId;
                                this.groupName = group.grpName;
                                this.grpLevel = group.level;
                            }
                            this.userGroupSelected = this.userGroupId;
                        }
                        this.onPageLoad();
                    });
                }

            } else {
                this.messageService.logOut();
            }
        });
    }

    onPageLoad() {
        if (this.messageService.upload_path === this.messageService.LNT_SSC_PATH) {
            this.displaySSC = true;
        } else if (this.messageService.upload_path === this.messageService.LNT_IMS_PATH) {
            this.displayIMS = true;
        } else if (this.messageService.upload_path === this.messageService.LNT_CHR_PATH) {
            this.displayCHR = true;
        } else if (this.messageService.upload_path === this.messageService.LNT_APPS_PATH) {
            this.displayAPPS = true;
        }

        this.columnDefinitions = [
            // {id: 'id', name: 'Id', field: 'id', minWidth: 80, sortable: true, filterable: true},
            {id: 'ticket_id', name: 'Ticket Id', field: 'ticket_id', minWidth: 200, sortable: true, filterable: true},
            {id: 'ticket_name', name: 'Ticket Title', field: 'tName', minWidth: 200, sortable: true, filterable: true},
            {
                id: 'createdBy', name: 'Created By', field: 'createdBy', minWidth: 150, sortable: true, filterable: true
            },
            {
                id: 'createdSince',
                name: 'Created Since',
                field: 'createdSince',
                minWidth: 150,
                sortable: true,
                filterable: true,
                type: FieldType.dateIso
            },
            {
                id: 'status', name: 'Status', field: 'status', sortable: true, minWidth: 150, filterable: true
            },
            {
                id: 'reqInfo', name: 'RequesterInfo', field: 'reqInfo', minWidth: 100, sortable: true, filterable: true
            },
            {
                id: 'assignee', name: 'Assignee', field: 'assignee', minWidth: 200, sortable: true, filterable: true
            },
            {
                id: 'LEVELSHORTDESC', name: 'Group', field: 'LEVELSHORTDESC', minWidth: 100, sortable: true, filterable: true
            },
            {
                id: 'dDate',
                name: 'Due Date',
                field: 'dDate',
                minWidth: 150,
                sortable: true,
                filterable: true,
                // formatter: Formatters.dateTimeIso,
                type: FieldType.dateIso
            },
            {
                id: 'updateDate',
                name: 'Last Update Date',
                field: 'updateDate',
                minWidth: 150,
                sortable: true,
                filterable: true,
                type: FieldType.dateIso
            },
            {
                id: 'updateBy', name: 'Last Updated By', field: 'updateBy', minWidth: 100, sortable: true, filterable: true
            },
            {
                id: 'closureDate', name: 'Closure Date', field: 'ticketCloseDate', minWidth: 150, sortable: true, filterable: true
            },
            {
                id: 'escLevel',
                name: 'Escalation Level',
                field: 'escalated_to_grp_nm',
                minWidth: 150,
                sortable: true,
                filterable: true
            }
        ];
        this.getTicketDetails();
    }

    getTicketDetails() {
        this._rest.getAnyTicketById({clientId: this.clientId, ticketId: this.ticket_no}).subscribe((res) => {
            this.respObject = res;
            if (this.respObject.success) {
                const data = this.respObject.details;
                // console.log(JSON.stringify(data));
                this.typeChecked = data[0].ticketTypeId;
                this.seq = data[0].ticket_seq;
                this.inciId = data[0].inci_id;
                this.dataset = data;
            } else {
                // alert(this.respObject.errorMessage);
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            // alert(this.messageService.SERVER_ERROR);
        });
    }

    getColumnDefintion() {
        this._rest.getAttributesHeaderMstClientWiseWithTicket(this.clientId, this.typeChecked).subscribe((res2) => {
            this.respObject = res2;
            if (this.respObject.success) {
                const data = this.respObject.details;
                // // console.log(JSON.stringify(data));
                this.columnDefinitions = [
                    // {id: 'id', name: 'Id', field: 'id', minWidth: 80, sortable: true, filterable: true},
                    {id: 'ticket_id', name: 'Ticket Id', field: 'ticket_id', minWidth: 200, sortable: true, filterable: true},
                    {id: 'ticket_name', name: 'Ticket Title', field: 'tName', minWidth: 200, sortable: true, filterable: true},
                    {
                        id: 'createdBy', name: 'Created By', field: 'createdBy', minWidth: 150, sortable: true, filterable: true
                    },
                    {
                        id: 'createdSince',
                        name: 'Created Since',
                        field: 'createdSince',
                        minWidth: 150,
                        sortable: true,
                        filterable: true,
                        type: FieldType.dateIso
                    },
                    {
                        id: 'status', name: 'Status', field: 'status', sortable: true, minWidth: 150, filterable: true
                    },
                    {
                        id: 'reqInfo', name: 'RequesterInfo', field: 'reqInfo', minWidth: 100, sortable: true, filterable: true
                    },
                    {
                        id: 'assignee', name: 'Assignee', field: 'assignee', minWidth: 200, sortable: true, filterable: true
                    },
                    {
                        id: 'LEVELSHORTDESC', name: 'Group', field: 'LEVELSHORTDESC', minWidth: 100, sortable: true, filterable: true
                    },
                    {
                        id: 'dDate',
                        name: 'Due Date',
                        field: 'dDate',
                        minWidth: 150,
                        sortable: true,
                        filterable: true,
                        // formatter: Formatters.dateTimeIso,
                        type: FieldType.dateIso
                    },
                    {
                        id: 'updateDate',
                        name: 'Last Update Date',
                        field: 'updateDate',
                        minWidth: 150,
                        sortable: true,
                        filterable: true,
                        type: FieldType.dateIso
                    },
                    {
                        id: 'updateBy', name: 'Last Updated By', field: 'updateBy', minWidth: 100, sortable: true, filterable: true
                    },
                    {
                        id: 'closureDate', name: 'Closure Date', field: 'ticketCloseDate', minWidth: 150, sortable: true, filterable: true
                    },
                    {
                        id: 'escLevel',
                        name: 'Escalation Level',
                        field: 'escalated_to_grp_nm',
                        minWidth: 150,
                        sortable: true,
                        filterable: true
                    }
                ];
                if (this.grpLevel !== 0) {
                    this.columnDefinitions.push({
                        id: 'priority', name: 'Priority', field: 'priority', minWidth: 100, sortable: true, filterable: true
                    });
                }
                for (let i = 0; i < data.length; i++) {
                    this.columnDefinitions.push({
                        id: data[i].field, name: data[i].name, field: data[i].field, minWidth: 100, sortable: true, filterable: true
                    });
                }
                const classes = document.getElementsByClassName('search-filter');
                for (let i = 0; i < classes.length; i++) {
                    classes[i].setAttribute('placeholder', '');
                }
            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            this.notifier.notify('error', JSON.stringify(err));
        });
    }

    ngOnDestroy(): void {
        if (this.userAuth) {
            this.userAuth.unsubscribe();
        }
    }

    onCellClicked(e, args) {
        const selectedRow = this.angularGrid.gridService.getColumnFromEventArguments(args);
        const data = selectedRow.dataContext;
        this.messageService.setModalData(data);
        this.setDisplayModal();
    }

    setDisplayModal() {
        if (this.seq === 5) {
            this.displayCr = true;
            this.displayPr = false;
            this.displayCit = false;
        } else if (this.seq === 6) {
            this.displayPr = true;
            this.displayCr = false;
            this.displayCit = false;
        } else {
            this.displayCit = true;
            this.displayPr = false;
            this.displayCr = false;
        }
    }

    onSelectGroup() {
        // // console.log(typeof this.userGroupSelected);
        if (this.userGroupSelected !== 0) {
            this.userGroupId = this.userGroupSelected;
            for (let i = 0; i < this.userGroups.length; i++) {
                if (this.userGroups[i].groupId === this.userGroupId) {
                    this.groupName = this.userGroups[i].grpName;
                    this.grpLevel = this.userGroups[i].level;
                }
            }
            this.messageService.saveSupportGroup({groupId: this.userGroupId, grpName: this.groupName, level: this.grpLevel});
            // this.onPageLoad();
        }
    }
}
